import React from 'react';
import { FieldTitle } from '../common/index';
import BrowserLocation from '../../browserLocation';

const emailParsed = (options) => {
  let value = options && options.value && options.value.length ? options.value : '';
  const emailFromParam = BrowserLocation.uriParams().email;

  if (emailFromParam !== undefined && emailFromParam !== '' && emailFromParam !== 'undefined') {
    value = emailFromParam;
  }

  return value;
};

class EmailInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: emailParsed(props.options)
    };

    // These bindings are necessary to make `this` work in the callbacks
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  render() {
    const { value } = this.state;
    const { label, internalTitle, formId, required, placeholder, className } = this.props;
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
    const asterisk = required ? ' *' : null;

    const usedLabel = label.length ? (
      <label htmlFor={forId}>
        {label}
        {asterisk}
      </label>
    ) : null;

    return (
      <div className={`${className} input email`}>
        {usedLabel}
        <input
          type="email"
          name={internalTitle}
          id={forId}
          placeholder={required && !label.length ? `${placeholder} *` : placeholder}
          value={value}
          onChange={this.handleChange}
          required={required}
        />
      </div>
    );
  }
}

EmailInput.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  required: React.PropTypes.bool,
  options: React.PropTypes.object,
  className: React.PropTypes.string
};

EmailInput.defaultProps = {
  className: 'formgroup'
};

export default EmailInput;



// WEBPACK FOOTER //
// ./components/forms/emailInput.js